import { useLocation } from "react-router-dom";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { getContactForRoute } from "../data/contactRouting";

function FloatingActions() {
  const location = useLocation();
  const contact = getContactForRoute(location.pathname);

  return (
    <div className="fixed bottom-4 right-4 z-[998] flex flex-col gap-3">
      <a
        href={`https://wa.me/${contact.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-emerald-600 text-xl text-white shadow-xl shadow-emerald-950/20 transition hover:-translate-y-0.5 hover:bg-emerald-700"
      >
        <FaWhatsapp />
      </a>
      <a
        href={`tel:${contact.phone}`}
        aria-label="Call VIP Groups"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-lg text-emerald-700 shadow-xl shadow-emerald-950/15 ring-1 ring-emerald-100 transition hover:-translate-y-0.5 hover:bg-emerald-50 sm:hidden"
      >
        <FaPhoneAlt />
      </a>
    </div>
  );
}

export default FloatingActions;
